// One slow editorial marquee carrying the brand statement.
// The item set repeats 4× per track so the strip stays dense on wide
// screens and the -50% loop seam is invisible (identical spacing at joins).
export function Marquee({ items, dark = false, className = "" }) {
  const row = `${Array(10).fill(items).flat().join("   •   ")}   •   `;
  return (
    <div
      aria-hidden="true"
      className={`overflow-hidden border-y py-4 ${
        dark ? "border-zinc-800 bg-charcoal text-zinc-400" : "border-zinc-200 bg-paper text-zinc-500"
      } ${className}`}
    >
      <div className="animate-marquee flex w-max whitespace-nowrap font-mono text-xs uppercase tracking-[0.35em]">
        <span>{row}</span>
        <span>{row}</span>
      </div>
    </div>
  );
}
